import React, {useEffect,useState,useRef} from "react";
import "../../../Components/ProductRegal/ProductRegal.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
// import {useBasket, useDispatchBasket} from "../../hooks";
// import {BasketAddRemove} from "..";
import {
    getCats_api,
    getMallCats_api,
    getProductsCategory_api,
    getProductsMall_api,
    getSampleProduct_api
} from "../../../Services/apis"

import { LeftOutlined,RightOutlined } from '@ant-design/icons';
import {convertRialToToman, getMallColor} from "../../../Services";

// let merchantRegal = ""
// let catRegal = ""

const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 20
        },
        400: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        320: {
            slidesPerView: 'auto',
            spaceBetween: 8
        }
    }

}


const catParams = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function ProductRegalNewDesktop({item,sort=false}) {
    //hooks
    const history = useHistory();

    const [merchantRegal,set_merchantRegal] = useState("")
    const [catRegal,set_catRegal] = useState("")

    const [regalFlag,set_regalFlag] = useState(true)
    const [data,setData] = useState([])
    const [cats,setCats] = useState([])
    const [currentCat,set_currentCat] = useState(null)
    const [color,setColor] = useState("#E0E0E0")



    const [mallPrimaryColor, set_mallPrimaryColor] = useState('');
    const [mallSecondaryColor, set_mallSecondaryColor] = useState('');

    useEffect(()=>{
        let {primary, secondary} = getMallColor()
        set_mallPrimaryColor(primary)
        set_mallSecondaryColor(secondary)
    },[])

    const [swiper, setSwiper] = useState(null);

    const ref = useRef(null);

    const goNext = () => {
        console.log(ref.current.swiper)
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slidePrev();
        }
    };


    useEffect( ()=>{
        getProductsMall()
    },[])

    const selectCat = (c)=>{
        set_currentCat(c)
        getCatProducts(c.uid)
        if(c.name)
            item.title = c.name
    }

    const getCatProducts = async (cId)=>{
        try{
            let split = item.items[0].text.split("@")
            //set for more product
            set_merchantRegal(split[1])
            // merchantRegal = split[1]
            console.log("cId : ",cId)
            // catRegal = cId
            set_catRegal(cId)
            const res = await getProductsCategory_api(split[1],cId)
            let proData = {data:res}
            set_regalFlag(false)
            setData(proData.data.results)
            set_regalFlag(true)
            if(item.items[0].link_to_uid)
                setColor(item.items[0].link_to_uid)
        }catch (e) {
            console.log(e)
        }

    }

    const getProductsMall = async ()=>{
        if(item.items[0].text){
            try{
                let split = item.items[0].text.split("@")
                //set for more product
                // merchantRegal = split[1]
                set_merchantRegal(split[1])
                console.log("split[0] : ",split[0])
                // catRegal = split[0]
                set_catRegal(split[0])

                const res = await getProductsCategory_api(split[1],split[0])
                let proData = {data:res}
                setData(proData.data.results)
                selectCat({uid:split[0]})
                getCats(split[1],split[2])
                if(item.items[0].link_to_uid)
                    setColor(item.items[0].link_to_uid)
            }catch(e){
                console.log(e)
            }
        }
    }

    const getCats = async(mId,pId)=>{
        try{
            const res = await getCats_api(mId,pId)
            // let data = res.data.result
            let proData = {data:res}
            setCats(proData.data)
        }catch (e) {
            console.log(e)
        }
    }


    const seeMoreProduct = ()=>{

        console.log("Cat : ",catRegal)
        console.log("Merchant : ",merchantRegal)

        history.push(`/dr-shop/search/${merchantRegal}/${catRegal}`)
    }

    const [sortSelect,set_sortSelect] = useState("discounts")
    const handleChangeSort = async (val)=>{
        set_sortSelect(val)
        // selectCat(currentCat)
        try{
            let split = item.items[0].text.split("@")
            //set for more product
            // merchantRegal = split[1]
            set_merchantRegal(split[1])
            // catRegal = currentCat.uid
            set_catRegal(currentCat.uid)
            console.log("-------------------------------------",val)
            const res = await getProductsCategory_api(split[1],currentCat.uid,val)
            let proData = {data:res}
            setData(proData.data.results)
            if(item.items[0].link_to_uid)
                setColor(item.items[0].link_to_uid)
        }catch (e) {
            console.log(e)
        }
    }

    return(
        // <span>swiper ...</span>
        <div className="desktop-regal-wr" style={{margin: "20px 16px 0 16px",backgroundColor:mallSecondaryColor}}>
            <div className="regal-handle-left" onClick={e=>{
                goNext()
            }}>
                <LeftOutlined />
            </div>
            <div className="regal-handle-right" onClick={e=>{
                goPrev()
            }}>
                <RightOutlined />
            </div>
            {cats && cats.length>0?
                <SwiperId {...catParams}>
                    {cats.map(d=>{
                        return(
                            <div className="pointer swiper-card-container cat-slide" style={currentCat?.uid===d.uid?{backgroundColor:mallPrimaryColor,color:"white"}:{backgroundColor:"#E0E0E0",color:"black"}} onClick={e=>{
                                selectCat(d)
                            }}>
                                <span>{d.name}</span>
                            </div>
                        )
                    })}

                </SwiperId>:null}

            {regalFlag?<div className="online-off-section" style={{
                backgroundColor: color,
                margin: "10px 0",
                padding: 8,
            }}>
                {data && data.length>0? <SwiperId ref={ref} {...imageParamss}>
                    <div className="pointer swiper-card-container product-desktop-cardi" style={{backgroundColor:"white",width:20,height:"auto"}}>
                        <div className="swiper-card-body">
                            <span>{item.title?item.title:"محصولات ویژه"}</span>

                            {sort?<div className="regal-sort-sec">
                                {/*<select name="" id="">*/}
                                {/*    <option value="">بروزترین</option>*/}
                                {/*    <option value="">ارزانترین</option>*/}
                                {/*    <option value="">گرانترین</option>*/}
                                {/*</select>*/}
                                <select
                                    value={sortSelect}
                                    onChange={e=>{handleChangeSort(e.target.value)}}
                                    name="" id="">
                                    <option value="-discounts"> بیشترین تخفیف</option>
                                    <option value="-sell">پر فروش ترین</option>
                                </select>
                            </div>:null}

                        </div>
                    </div>
                    {data.map(i=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container-desktop pointer" onClick={()=>{
                                    let split = item.items[0].text.split("@")
                                    // history.push(`/online-store-product/${split[1]}/${i.uid}`)
                                    history.push(`/dr-shop/detail/${split[1]}/${i.uid}`)
                                }}>
                                    <div className="swiper-card-body" >
                                        {/*<BasketAddRemove i={i}/>*/}
                                        <div className="swiper-card-body-image">
                                            {i.stock===0?<div className="notExist-badge">ناموجود</div>:null}
                                            <img src={i.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="price-section">
                                        <div className="price price-regal">
                                            {numberWithCommas(convertRialToToman(i.price))} تومان
                                        </div>
                                        {i.price_original-i.price>0?<div className="price-regal-off">
                                            {numberWithCommas(convertRialToToman(i.price_original))}تومان
                                        </div>:null}
                                    </div>
                                    {/*{i && i.discount_percentage!==0?*/}
                                    {/*    <div className="off">*/}
                                    {/*        <span>{i.discount_percentage+" % "}</span>*/}
                                    {/*    </div>:null*/}
                                    {/*}*/}
                                    <div className="info-section-desktop">
                                        <div className="name">{limitText(i.name,25)}</div>
                                        {/*<div className="weight">1500 گرمی میهن</div>*/}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body" style={{marginRight:20,marginTop:60}}>
                            <div className="swiper-more-card">
                                <span className="swiper-more-card-label-desktop">مشاهده محصولات </span>
                                <span onClick={seeMoreProduct} className="swiper-more-card-btn-desktop">بیشتر</span>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body">
                            <span></span>
                        </div>
                    </div>
                </SwiperId>:null}
            </div>:null}
        </div>

    )
}

export {ProductRegalNewDesktop};
